module.exports = __webpack_public_path__ + "static/media/siddharth-sakleshpur-trip-14.acfbd863.png";